module.exports = Object.keys || require('./shim');




//////////////////
// WEBPACK FOOTER
// ./~/object-keys/index.js
// module id = 1118
// module chunks = 142807904292071